module.exports = __webpack_public_path__ + "img/bg11.ce96cf6f.png";